export default __webpack_public_path__ + "static/media/Arolytics+Logo.ae28a6d0.png";